import { Obj } from '../utils';
export class Map<T> {
private _items: any;
private _size: number;
constructor() {
    this._items = {};
    this._size = 0;
  }
/**
 * Populates this map with the corresponding values
 * in the given object.
 * @param {?} from
 * @return {?}
 */
public populate(from: any): void {
    if(Obj.isNullOrUndefined(from)) {
      return;
    }
    for(let /** @type {?} */ key in from) {
      if(from.hasOwnProperty(key)) {
        this._items[key] = from[key];
      }
    }
  }
/**
 * Seeds the values in the given object with the
 * corresponding values in this map.
 * @param {?} to
 * @return {?}
 */
public seed(to: any): void {
    if(Obj.isNullOrUndefined(to)) {
      return;
    }
    this.forEach((value: any, key: string) => {
      if(to.hasOwnProperty(key)) {
        to[key] = value;
      }
    });
  }
/**
 * Iterates over each item in the map, skipping
 * any entries whose key is null.
 * @param {?} predicate
 * @return {?}
 */
public forEach(predicate: Function): void {
    for(let /** @type {?} */ key in this._items) {
      if(Obj.isNullOrUndefined(key)) {
        continue;
      }
      predicate(this._items[key], key);
    }
  }
}

function Map_tsickle_Closure_declarations() {
/** @type {?} */
Map.prototype._items;
/** @type {?} */
Map.prototype._size;
}
